<template>
  <div class="agent">
    <header class="agent-header">
      <div class="inner">
        <div class="row">
          <div class="col-9">
            <router-link to="/">
              <img src="../assets/images/back@2x.png" class="back">
            </router-link>
            {{$t('vacationMode')}}
          </div>
          <div class="col-3 switch">
            <input type="checkbox" name="vacation" id="vacation" v-model="isVacation" value="true" @change="setVacation">
            <label for="vacation"></label>
          </div>
        </div>
      </div>
    </header>
    <main class="main-content">
      <div class="section set-date">
        <div class="inner">
          <h5>{{$t('agentDates')}}</h5>
          <div class="form-group" :class="errorMsgStartDate ? 'form-error': ''">
            <div class="row">
              <div class="col-4">
                {{$t('startDate')}}
              </div>
              <div class="col-8 invisitTime">
                <dateTimePicker
                  :isStartDate="true"
                  @change="inputDate"
                  v-model="startDate"
                  :placeholder= "$t('chooseDate')"
                >
                </dateTimePicker>
              </div>
            </div>
          </div>
          <label class="error-msg"  v-show="errorMsgStartDate">{{errorStartDate}}</label>
          <div class="form-group" :class="errorMsgEndDate ? 'form-error': ''">
            <div class="row">
              <div class="col-3">
                {{$t('endDate')}}
              </div>
              <div class="col-9 invisitTime">
                <dateTimePicker
                  :isEndDate="true"
                  @change="inputDate"
                  v-model="endDate"
                  :placeholder= "$t('chooseEndDate')"
                >
                </dateTimePicker>
              </div>
            </div>
          </div>
          <label class="error-msg" v-show="errorMsgEndDate">{{errorEndDate}}</label>
        </div>
      </div>
      <div class="section agent-list">
        <div class="inner">
          <h5>{{$t('chooseAgent')}}</h5>
          <label class="error-msg" v-show="errorMsgAgent">{{errorAgent}}</label>
          <div class="agent-list-content" :class="isVacation ? 'open-vacation': ''">
            <div class="no-data" v-if="!agentList.length">
              {{$t('noRelevantAgent')}}
            </div>
            <div class="view-content" v-else>
              <div class="form-group" v-for="(user, idx) in agentList" :key="idx">
                <div class="row">
                  <div class="col-10">
                    <img class="head-portrait" :id="user.backUpId" :src="user.backUpAvatar">
                    <span>{{ user.backUpName }}({{ user.backUpDeptName }})</span>
                  </div>
                  <div class="col-2">
                    <div class="check-item">
                      <input
                        type="radio"
                        name="agent"
                        :value="user.backUpId"
                        :id="'agent_' + user.backUpId"
                        v-model="selectedAgent"
                        @change="setAgent">
                      <label :for="'agent_' + user.backUpId"></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overlay" v-show="!isVacation"></div>
    </main>
    <transition name="fade">
      <footer class="agent-footer fixed-bottom" v-show="isVacation">
        <button class="btn" @click="submitData">{{$t('submit')}}</button>
      </footer>
    </transition>
    <transition name="fade">
      <div class="tip" v-show="this.modalTip">
        <div class="tip-inner">
          <div class="tip-text">{{modalTipText}}</div>
          <router-link to="/" class="comfirmBtn">{{$t('confirm')}}</router-link>
        </div>
      </div>
    </transition>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
  </div>
</template>

<script>
import { getAgent, submitAgent, cancelAgent } from '@/utils/api';
import { checkNested } from '@/utils/utils';
import Moment from 'moment';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import dateTimePicker from '@/components/dateTimePicker.vue';

export default {
  name: 'Agent',
  components: {
    Loading,
    dateTimePicker,
  },
  data() {
    return {
      isVacation: false,
      startDate: '',
      endDate: '',
      errorMsgStartDate: false,
      errorStartDate: this.$t('pleaseChooseStartDate'),
      errorMsgEndDate: false,
      errorEndDate: this.$t('pleaseChooseEndDate'),
      agentList: [],
      selectedAgent: '',
      selectedAgentArr: [],
      errorMsgAgent: false,
      errorAgent: this.$t('pleaseChooseAgent'),
      modalTip: false,
      modalTipText: '',
      isLoading: false,
    }
  },
  created: function () {
    this.getAgentList();
  },
  methods: {
    setVacation() {
      if (!this.isVacation) {
        this.isLoading = true;
        cancelAgent().then((res) => {
          this.isLoading = false;
          this.startDate = '';
          this.endDate = '';
          this.selectedAgent =[];
          this.agentList.forEach(x => x.enableBackUp = false);
          if (checkNested(res, 'data', 'content', 'model')) {
            this.modalTip = true;
            this.modalTipText = res.data.content.message;
          }
        });
      }
    },
    inputDate() {
      const { startDate, endDate } = this;
      const date = new Date();
      let diff = 0;
      if (startDate) {
        const strArr = startDate.split(' ');
        diff = Moment(new Date(`${strArr[0]}T${strArr[1]}:00`)) - Moment(date);
        if (diff < 0) {
          this.errorMsgStartDate = true;
          this.errorStartDate = this.$t('entered');
        } else {
          this.errorMsgStartDate = false;
          this.errorStartDate = '';
        }
        if (endDate) {
          diff = Moment(endDate) - Moment(startDate);
          if (diff < 0) {
            this.errorMsgEndDate = true;
            this.errorEndDate = this.$t('endDateMustBeLater');
          } else {
            this.errorMsgEndDate = false;
            this.errorEndDate = '';
          }
        }
      }
    },
    setAgent() {
      if (this.selectedAgent == '') {
        this.errorMsgAgent = true;
        this.errorAgent = this.$t('pleaseChooseAgent');
      } else {
        this.errorMsgAgent = false;
        this.errorAgent = '';
        this.selectedAgentArr = [this.selectedAgent];
      }
    },
    getAgentList() {
      this.isLoading = true;
      getAgent().then((res) => {
        this.isLoading = false;
        if (checkNested(res, 'data', 'content', 'model', 'backUpModels')) {
          this.agentList = res.data.content.model.backUpModels;
          if (Moment(res.data.content.model.endTime) > Moment(new Date())) {
            this.agentList.forEach(x => {
              if (x.enableBackUp) {
                this.selectedAgentArr = [x.backUpId];
                this.selectedAgent = x.backUpId;
              }
            });
            this.isVacation = true;
            this.startDate = res.data.content.model.startTime;
            this.endDate = res.data.content.model.endTime;
          } else {
            this.agentList.forEach(x => x.enableBackUp = false);
          }
        }
      });
    },
    submitData() {
      this.errorMsgStartDate = !this.startDate ? true : this.errorMsgStartDate;
      this.errorMsgEndDate = !this.endDate ? true : this.errorMsgEndDate;
      this.errorMsgAgent = !this.selectedAgentArr.length;
      if (!this.errorMsgStartDate && !this.errorMsgEndDate && !this.errorMsgAgent) {
        const agentObj = {
          'startTime': this.startDate,
          'endTime': this.endDate,
          'backUpIdList': this.selectedAgentArr
        }
        submitAgent(agentObj).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            this.modalTip = true;
            this.modalTipText = res.data.content.message;
          }
        });
      }
    },
  }
};
</script>
<style scoped lang="scss">
.inner {
  width: 90%;
  margin: 0 auto;
}
.agent {
  .tip {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.4);
    .tip-inner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 270px;
      border-radius: 12px;
      background-color: #fcfcfc;
      text-align: center;
      .tip-text {
        padding: 20px 0 15px;
        font-size: 17px;
        color: #4a4a4a;
      }
      .comfirmBtn {
       padding: 12px;
       font-size: 17px;
       color: #e42029;
       display: block;
      }
    }
    .icon-close {
      position: absolute;
      top: 10px;
      right: 5%;
      z-index: 10;
      font-size: 22px;
    }
  }
  img {
    max-width: 100%;
  }
  .error-msg {
    color: #e42029;
    font-size: 11px;
    text-align: right;
    width: 100%;
    &.right-padding {
      padding-right: 12px;
    }
  }
  .no-data {
    font-size: 14px;
    text-align: center;
    color: #929292;
    font-weight: bold;
    padding-top: 40px;
  }
  .open-vacation {
    padding-bottom: 67px;
  }
  .form-group {
    border-bottom: 1px solid #f0f1f2;
    margin-bottom: 0;
    padding: 15px 0;
    font-size: 14px;
  }
  .form-error {
    border-bottom: 1px solid red;
  }
  .head-portrait {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 16px;
  }
}
.agent-header {
  padding: 20px 0;
  .back {
    padding-right: 10px;
    width: 32px;
  }
}
.main-content {
  position: relative;
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
  }
}
.section {
  color: #4a4a4a;
  line-height: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f1f2;
  .inner {
    margin-bottom: -1px;
    position: relative;
  }
  h5 {
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 0;
    & + .error-msg {
      position: absolute;
      top: -5px;
      right: 0;
    }
  }
  .col-3 {
    font-size: 14px;
  }
  .col-9 {
    text-align: right;
    font-size: 13px;
    input {
      color: #4a4a4a;
      text-align: right;
      border: none;
      outline: none;
      width: 100%;
    }
  }
}
.agent-footer {
  background: #fff;
  padding: 15px 20px;
  box-shadow: 0 0 15px rgba(100,100,100,.15);
  align-items: center;
  label.checkAll {
    font-size: 16px;
    margin: 0;
    input[type='checkbox'] {
      width: 23px;
      height: 23px;
      appearance: none;
      background-color: #fff;
      outline: none;
      background: url(../assets/images/copy-21.png) no-repeat center;
      vertical-align: text-bottom;
      margin-bottom: -1px;
      margin-right: 7px;
    }
    input[type='checkbox']:checked {
      border: none;
      background: url(../assets/images/zhengque.png) no-repeat center;
    }
  }
  .btn {
    color: #fff;
    width: 100%;
    font-weight: 15px;
    font-weight: 600;
    background-image: linear-gradient(73deg, #f36443, #e42029);
    &:focus,
    &:hover {
      box-shadow: none;
      color: #fff;
    }
  }
}
.check-item {
  position: relative;
  top: 11px;
  text-align: right;
  label {
    display: block;
    margin: 0;
    &:before,
    &:after {
      content: '';
      position: absolute;
      display: block;
      transition: all ease .3s;
    }
    &:before {
      border: solid 2px #bebebe;
      border-radius: 9px;
      width: 18px;
      height: 18px;
      top: 0;
      right: 0;
    }
  }
  input {
    display: none;
    &:checked {
      & + label {
        &:before {
          border-color: #e42029;
        }
        &:after {
          background: #e42029;
          border-radius: 4px;
          width: 8px;
          height: 8px;
          display: block;
          top: 5px;
          right: 5px;
        }
      }
    }
  }
}
.switch {
  height: 26px;
  text-align: right;
  label {
    position: relative;
    width: 48px;
    height: 26px;
    margin: 0;
    &:before,
    &:after {
      content: '';
      position: absolute;
      display: block;
      transition: all ease .3s;
    }
    &:before {
      background: #dadada;
      border-radius: 13px;
      width: 48px;
      height: 26px;
      top: 0;
      right: 0;
    }
    &:after {
      background: #fff;
      border-radius: 11px;
      width: 22px;
      height: 22px;
      display: block;
      top: 2px;
      right: 24px;
    }
  }
  input {
    display: none;
    &:checked {
      & + label {
        &:before {
          background: #e42029;
        }
        &:after {
          right: 2px;
        }
      }
    }
  }
}
</style>
